/**
 * Generates a consistent test ID based on a property label
 * Converts label to lowercase and replaces spaces with hyphens
 */
export const getPropertyTestId = ( label: string ): string => {
  return `property-${ label.toLowerCase().replace( /\s+/g, '-' ) }`;
};